import { native } from '@forest/native-services'
import { dialog } from '@forest/shared/solid'
import { m } from '~/paraglide/messages'
import { SHOP_ALERT_DIALOG } from './shop-purchase-dialog'

// Where "Go to Settings" sends the user: native's Settings page opened on
// its Land Style cell. Native dismisses Shop when it handles this link, so
// the prompt neither closes Shop nor syncs — the land skin's full sync
// already fired when its purchase committed (GLOSSARY.md "Shop close sync").
const LAND_STYLE_SETTINGS_URL =
  'forestapp://main_page/settings_page?select_cell=settings_theme'

/**
 * The land-skin apply prompt (GLOSSARY.md): the dialog that follows a
 * land-skin unlock's success reveal, asking whether to use the new land
 * style now. Resolves when the dialog has left the screen, whichever button
 * answered it — the unlock celebration waits on that.
 */
export function openLandSkinApplyPrompt(): Promise<void> {
  return dialog.open({
    ...SHOP_ALERT_DIALOG,
    action: () => void native.general.openURL(LAND_STYLE_SETTINGS_URL),
    button: m.go_to_settings(),
    buttonLayout: 'vertical',
    buttonTestId: 'land-skin-apply-prompt-settings',
    description: m.dialog_use_land_skin_content(),
    // Maybe Later has nothing to do but close; nothing is remembered.
    secondaryButton: {
      action: () => {},
      button: m.btn_maybe_later(),
      testId: 'land-skin-apply-prompt-later',
    },
    testId: 'land-skin-apply-prompt',
    title: m.dialog_use_land_skin_title(),
  })
}
